import { render, staticRenderFns } from "./CertificateAccess.vue?vue&type=template&id=e85fe5cc&scoped=true"
import script from "./CertificateAccess.vue?vue&type=script&lang=js"
export * from "./CertificateAccess.vue?vue&type=script&lang=js"
import style0 from "./CertificateAccess.vue?vue&type=style&index=0&id=e85fe5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85fe5cc",
  null
  
)

export default component.exports